var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVkontakte(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_424_27768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 23.04C0 12.1788 0 6.74826 3.37413 3.37413C6.74826 0 12.1788 0 23.04 0H24.96C35.8212 0 41.2517 0 44.6259 3.37413C48 6.74826 48 12.1788 48 23.04V24.96C48 35.8212 48 41.2517 44.6259 44.6259C41.2517 48 35.8212 48 24.96 48H23.04C12.1788 48 6.74826 48 3.37413 44.6259C0 41.2517 0 35.8212 0 24.96V23.04Z",
    fill: "#0077FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.54 34.5796C14.6 34.5796 8.3601 27.0796 8.1001 14.5996H13.5801C13.7601 23.7596 17.8 27.6396 21 28.4396V14.5996H26.1602V22.4996C29.3202 22.1596 32.6398 18.5596 33.7598 14.5996H38.9199C38.0599 19.4796 34.4599 23.0796 31.8999 24.5596C34.4599 25.7596 38.5601 28.8996 40.1201 34.5796H34.4399C33.2199 30.7796 30.1802 27.8396 26.1602 27.4396V34.5796H25.54Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_424_27768"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVkontakte);
export default __webpack_public_path__ + "static/media/vkontakte.4469cc5ef86f9856cbdb50c4b884a4ba.svg";
export { ForwardRef as ReactComponent };